<div class="panel-header branding-accent-normal-background">
  <ng-content *ngIf="!header; else headerText" select="[panel-header]"></ng-content>
  <ng-template #headerText>
    <div class="panel-header-text">{{header | translate}}</div>
  </ng-template>
</div>

<div class="panel-body" [class.mod-table]="table">
  <ng-content select="[panel-body]"></ng-content>
</div>
